import Component from 'flarum/common/Component';
import LogInModal from "flarum/components/LogInModal";
import UserLogoutConfirmationModal from './modal/UserLogoutConfirmationModal';

export default class StatisticBasicComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    return (
      <div>
        <div className="u2diLogoContainer">
          <img style="max-height: 30px;" src={app.forum.attribute('logoUrl')} />
        </div>
        <div className="u2diLogoMobileContainer" onclick={(e)=>{ if(app.session.user===null){app.modal.show(LogInModal);}else{app.modal.show(UserLogoutConfirmationModal);} }}>
          <img style="max-height: 30px;" src={app.forum.attribute('logoUrl')} />
        </div>
      </div>
    );
  }

}